<template>
    <div class="text-h4 pa-2">
        {{ valor | separadores }}
        <span class="text-subtitle-1 font-weight-bold"> {{ etiqueta_unidad }}</span>
    </div>
</template>

<script>
import GraficasService from "@services/GraficasService";

export default {
    props: ["labels", "dataset", "opciones"],
    data: () => ({
        valor: "",
        etiqueta_unidad: "",
    }),

    mounted() {
        this.valor = this.dataset[0].datos;
        this.etiqueta_unidad = this.dataset[0].etiqueta_unidad;
    },

    filters: {
        separadores: GraficasService.addSeparadores,
    },
};
</script>
